/**
 * The lazy locale chunks, named in ONE module that only the entry imports
 * (job #966). See the note above LOCALE_CODES in composables/useI18n.ts for why
 * these import()s cannot live in useI18n itself: every chunk that uses t()
 * would be renamed, and re-downloaded by every installed phone, whenever a
 * locale or the English deferred half changed.
 *
 * Importing this module registers the loaders. main.js imports it; so does any
 * test that needs a non-English locale actually loaded.
 */
import { registerLocaleLoaders, type LocaleLoaders } from '@/composables/useI18n'

const unwrap = (m: any): Record<string, any> => (m && m.default) || m

// Each one becomes its own Vite chunk; only the locale the user picks is fetched.
// No `eng`: English is in the app statically and always already loaded.
const cymLoader = () => import('../locales/cym.json').then(unwrap)
export const LOCALE_LOADERS: LocaleLoaders = {
  gle: () => import('../locales/gle.json').then(unwrap),
  ga: () => import('../locales/gle.json').then(unwrap), // 639-1 alias
  spa: () => import('../locales/spa.json').then(unwrap),
  cym: cymLoader,
  cym_n: cymLoader, // dialect codes share the same locale file
  cym_s: cymLoader,
  ara: () => import('../locales/ara.json').then(unwrap),
  deu: () => import('../locales/deu.json').then(unwrap),
  fra: () => import('../locales/fra.json').then(unwrap),
  ita: () => import('../locales/ita.json').then(unwrap),
  jpn: () => import('../locales/jpn.json').then(unwrap),
  kor: () => import('../locales/kor.json').then(unwrap),
  por: () => import('../locales/por.json').then(unwrap),
  zho: () => import('../locales/zho.json').then(unwrap),
  cmn: () => import('../locales/zho.json').then(unwrap),
  // Indian-subcontinent + Sri Lanka
  sin: () => import('../locales/sin.json').then(unwrap),
  tam: () => import('../locales/tam.json').then(unwrap),
  hin: () => import('../locales/hin.json').then(unwrap),
  ben: () => import('../locales/ben.json').then(unwrap),
  guj: () => import('../locales/guj.json').then(unwrap),
  pan: () => import('../locales/pan.json').then(unwrap),
  urd: () => import('../locales/urd.json').then(unwrap),
  kan: () => import('../locales/kan.json').then(unwrap),
  mar: () => import('../locales/mar.json').then(unwrap),
  tel: () => import('../locales/tel.json').then(unwrap),
  // Other interface languages
  aze: () => import('../locales/aze.json').then(unwrap),
  lit: () => import('../locales/lit.json').then(unwrap),
  yor: () => import('../locales/yor.json').then(unwrap),
}

registerLocaleLoaders(LOCALE_LOADERS, () => import('virtual:eng-deferred'))
